import React from 'react';
import { X, Phone, MessageCircle, Mail, MapPin } from 'lucide-react';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactModal = ({ isOpen, onClose }: ContactModalProps) => {
  if (!isOpen) return null;

  const contactActions = [
    {
      icon: <Phone className="w-6 h-6" />,
      label: 'Call Us',
      action: 'tel:+919567810944',
      description: 'Speak directly with our team',
      color: 'bg-red-600 hover:bg-red-700'
    },
    {
      icon: <MessageCircle className="w-6 h-6" />,
      label: 'WhatsApp',
      action: 'https://wa.me/919567810944',
      description: 'Chat with us on WhatsApp',
      color: 'bg-[#25D366] hover:bg-[#20BD5A]'
    }
  ];

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" 
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative w-full max-w-lg bg-white rounded-xl shadow-lg p-6 md:p-8">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>

          <h2 className="text-2xl font-bold mb-6">Get in Touch</h2>

          {/* Contact Actions */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            {contactActions.map(({ icon, label, action, description, color }) => (
              <a
                key={label}
                href={action}
                target={action.startsWith('https') ? '_blank' : undefined}
                rel={action.startsWith('https') ? 'noopener noreferrer' : undefined}
                className={`flex flex-col items-center justify-center p-6 rounded-lg text-white transition-all ${color} hover:scale-105`}
              >
                {icon}
                <span className="text-lg font-medium mt-2">{label}</span>
                <span className="text-sm opacity-90 mt-1">{description}</span>
              </a>
            ))}
          </div>

          {/* Contact Info */}
          <div className="space-y-4 text-gray-600">
            <a 
              href="mailto:masterhomedevelopers@gmail.com"
              className="flex items-center hover:text-red-600 transition-colors"
            >
              <Mail className="w-5 h-5 mr-3" />
              masterhomedevelopers@gmail.com
            </a>
            <div className="flex items-start">
              <MapPin className="w-5 h-5 mr-3 mt-1 flex-shrink-0" />
              <span>
                SM COMPLEX, MAIN ROAD, near IRITTY TALUK CO-OP SOCIETY, 19TH MILE, KANNUR, Kerala 670702
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
